import React, { useState } from "react";
import Footer from "../Component/Footer";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phonenumber: "",
    message: "",
    acceptedTerms: false,
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleCheckboxChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      acceptedTerms: e.target.checked,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission
    console.log(formData);
  };
  return (
    <>
      <div
        id="subtitle-wrapper"
        className="lazyload"
        data-bg="image/subtitle-wrapper01.jpg"
      >
        <div
          className="subtitle-wrapper-img lazyload"
          data-bg="image/subtitle-wrapper01-img.jpg"
        >
          <div className="container container-fluid-xl">
            <div className="tt-breadcrumbs">
              <ul>
                <li>
                  <a href="index.html">home</a>
                </li>
                <li>Contact Us</li>
              </ul>
            </div>
            <h1 className="subtitle__title">Contact Us</h1>
          </div>
          <div className="bubbleContainer">
            <div className="bubble-1"></div>
            <div className="bubble-2"></div>
            <div className="bubble-3"></div>
            <div className="bubble-4"></div>
            <div className="bubble-5"></div>
            <div className="bubble-6"></div>
            <div className="bubble-7"></div>
            <div className="bubble-8"></div>
            <div className="bubble-9"></div>
            <div className="bubble-10"></div>
          </div>
        </div>
      </div>
      <main id="tt-pageContent">
        <div className="section-inner">
          <div className="container container-fluid-lg">
            <div className="title-block text-center">
              <div className="title-block__label">[ Get in Touch With Us ]</div>
              <h4 className="title-block__title">Contact Information</h4>
            </div>
            <div className="row info03__wrapper">
              <div className="col-custom-450 col-6 col-md-3">
                <div className="info03">
                  <i className="info03__icon icons-484169"></i>
                  <h6 className="info03__title">Post Address</h6>
                  <address>
                    8494 Signal Hill Road Manassas,
                    <br />
                    VA, 20110
                  </address>
                </div>
              </div>
              <div className="col-custom-450 col-6 col-md-3">
                <div className="info03">
                  <i className="info03__icon icons-483947"></i>
                  <h6 className="info03__title">Contact Phone</h6>
                  <address>
                    <a href="tel:1(800)7654321">1 (800) 765-43-21</a>
                  </address>
                </div>
              </div>
              <div className="col-custom-450 col-6 col-md-3">
                <div className="info03">
                  <i className="info03__icon icons-1004017"></i>
                  <h6 className="info03__title">E-mail Address</h6>
                  <address>
                    <a href="mailto:info@yourlaundrysite.com">
                      info@yourlaundrysite.com
                    </a>
                  </address>
                </div>
              </div>
              <div className="col-custom-450 col-6 col-md-3">
                <div className="info03">
                  <i className="info03__icon icons-59252"></i>
                  <h6 className="info03__title">Opening Hours</h6>
                  <address>Mon-Fri 08:00 AM - 05:00 PM</address>
                  <address>Sat-Sun 10:00 AM - 5:00 PM</address>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="tt-posirion-relative">
          <div className="container container-fluid-lg">
            <div className="row">
              <div className="col-lg-6">
                <div className="map-layout">
                  <div className="title-block">
                    <h4 className="title-block__title">
                      Get in Touch.
                      <br />
                      We're Here to Help.
                    </h4>
                  </div>
                  <p>
                    We look forward to helping you create and maintain a clean,
                    healthy environment that’s as enjoyable as it is functional.
                  </p>
                  <form
                    className="form-default"
                    id="contact-form"
                    method="post"
                    onSubmit={handleSubmit}
                    noValidate
                  >
                    <div className="form-group">
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        placeholder="Your name"
                        value={formData.name}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="row row-align-col">
                      <div className="col-md-6">
                        <div className="form-group">
                          <input
                            type="email"
                            name="email"
                            className="form-control"
                            placeholder="E-mail"
                            value={formData.email}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <input
                            type="text"
                            name="phonenumber"
                            className="form-control"
                            placeholder="Phone"
                            value={formData.phonenumber}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-group">
                      <textarea
                        name="message"
                        rows="7"
                        className="form-control"
                        placeholder="Your message"
                        value={formData.message}
                        onChange={handleInputChange}
                      ></textarea>
                    </div>
                    <div className="form-group">
                      <div className="checkbox-group">
                        <input
                          type="checkbox"
                          id="checkBox01"
                          name="checkbox"
                          checked={formData.acceptedTerms}
                          onChange={handleCheckboxChange}
                        />
                        <label htmlFor="checkBox01">
                          <span className="check"></span>{" "}
                          <span className="box"></span> I accept the privacy and
                          terms.
                        </label>
                      </div>
                    </div>
                    <div className="tt-btn tt-btn__wide">
                      <span className="mask">Send Question</span>
                      <button type="submit" className="button">
                        Send Message
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div
            id="map"
            className="map-layout-wrapper lazyload"
            data-bg="image/map-contact.jpg"
          >
            <iframe
              src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
              className="lazyload"
              data-expand="-220"
              data-src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3111.5820008392016!2d-77.45701318432829!3d38.75035326320268!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b65b93b943fb07%3A0xc8712e829da92b9e!2sHistoric%20District%2C%208494%20Signal%20Hill%20Rd%2C%20Manassas%2C%20VA%2020110%2C%20USA!5e0!3m2!1sen!2sua!4v1605172763191!5m2!1sen!2sua"
              allowFullScreen
              aria-hidden="false"
            ></iframe>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}

export default Contact;
